import { gql } from '@apollo/client';

export const DELETE_BILL_UPLOAD = gql`
  mutation Flex_DeleteBillUpload($id: Int!) {
    deleteBillUpload(id: $id) {
      id
    }
  }
`;
